export const incumplimientoConsumer = (data) => {

    return {
        affiliate: data["affiliate"],
        branch_id: data["branch_id"],
        info_date: data["info_date"],
        reference_number: data["reference_number"],
        client_data_date: data["client_data_date"],
        id_type_code: data["id_type_code"],
        provider_country_id: data["provider_country_id"],
        document_id: data["document_id"],
        first_surname: data["first_surname"],
        second_surname: data["second_surname"],
        first_name: data["first_name"],
        second_name: data["second_name"],
        birthdate: data["birthdate"],
        gender: data["gender"],
        personal_data_date: data["personal_data_date"],
        civil_status_code: data["civil_status_code"],
        document_type_spouse: data["document_type_spouse"],
        document_country_spouse: data["document_country_spouse"],
        document_number_spouse: data["document_number_spouse"],
        first_surname_spouse: data["first_surname_spouse"],
        second_surname_spouse: data["second_surname_spouse"],
        first_name_spouse: data["first_name_spouse"],
        second_name_spouse: data["second_name_spouse"],
        death_data_date: data["death_data_date"],
        death_publication_date: data["death_publication_date"],
        death_incorporation_date: data["death_incorporation_date"],
        email: data["email"],
        address_data_date: data["address_data_date"],
        personal_flag_tenant: data["personal_flag_tenant"],
        personal_street: data["personal_street"],
        personal_door_number: data["personal_door_number"],
        personal_appartment: data["personal_appartment"],
        personal_floor: data["personal_floor"],
        personal_complement: data["personal_complement"],
        personal_county: data["personal_county"], // duda
        personal_town: data["personal_town"],
        personal_postalcode: data["personal_postalcode"],
        //personal_street: data["personal_street"],// duda
        personal_phone_data_date: data["personal_phone_data_date"],
        personal_phone: data["personal_phone"],
        //personal_phone_data_date: data["personal_phone_data_date"],// duda
        cellphone: data["cellphone"],// duda
        job_data_date: data["job_data_date"],
        occupation: data["occupation"],
        company_employment: data["company_employment"],
        commercial_activity_workplace: data["commercial_activity_workplace"],
        hiring_date_workplace: data["hiring_date_workplace"],
        street_workplace: data["street_workplace"],
        house_number_workplace: data["house_number_workplace"],
        appartment_workplace: data["appartment_workplace"],
        floor_workplace: data["floor_workplace"],
        complement_address_workplace: ["complement_address_workplace"],
        departament_workplace: data["departament_workplace"],
        locality_workplace: data["locality_workplace"],
        postal_code_workplace: data["postal_code_workplace"],
        job_phone_data_date: data["job_phone_data_date"],
        phone_workplace: data["phone_workplace"],
        grant_date: data["grant_date"],
        currency_code: data["currency_code"],
        original_amount: data["original_amount"],
        payment: data["payment"],
        operation_type_code: data["operation_type_code"],
        due_date: data["due_date"],
        amount_fees: data["amount_fees"],
        member_rect: data["member_rect"],
        branch_code_rect: data["branch_code_rect"],
        reference_number_rect: data["reference_number_rect"],
        debt_purchase_date: data["debt_purchase_date"],// duda refinancing_status_date (fecha_operacion_rectificacion),
        refinancing_currency: data["refinancing_currency"],
        amount_rect: data["amount_rect"],
        term_rect: data["term_rect"],
        transaction_type_rect: data["transaction_type_rect"],
        default_date_rect: data["default_date_rect"],
        amount_fees_rect: data["amount_fees_rect"],
        //movimiento_rectificacion:data["movimiento_rectificacion"],
        //serie:data["serie"],
        //form:data["form"],

    }

}


export const incumplimientoCommercial = (data) => {

    return {
        affiliate: data["affiliate"],
        branch_id: data["branch_id"],
        info_date: data["info_date"],
        reference_number: data["reference_number"],
        document_id: data["document_id"], //rut
        company_fantasy_name: data["company_fantasy_name"],
        company_legal_name: data["company_legal_name"],
        company_commercial_businesses: data["company_commercial_businesses"],
        company_initiate_activities: data["company_initiate_activities"],
        record_date: data["record_date"],//fecha_datos_empresa:data["fecha_datos_empresa"]
        personal_flag_tenant: data["personal_flag_tenant"],
        street_workplace: data["street_workplace"], // duda personal_door_number:data["personal_door_number"]
        house_number_workplace: data["house_number_workplace"], //duda personal_street:data["personal_street"]
        appartment_workplace: data["appartment_workplace"],
        floor_workplace: data["floor_workplace"],
        complement_address_workplace: data["complement_address_workplace"],
        departament_workplace: data["departament_workplace"],
        locality_workplace: data["locality_workplace"],
        postal_code_workplace: data["postal_code_workplace"],
        phone_workplace: data["phone_workplace"],
        cellphone: data["cellphone"],
        email: data["email"],
        grant_date: data["grant_date"],
        currency_code: data["currency_code"],
        original_amount: data["original_amount"],
        payment: data["payment"],
        operation_type_code: data["operation_type_code"],
        due_date: data["due_date"],
        amount_fees: data["amount_fees"],
        member_rect: data["member_rect"],
        branch_code_rect: data["branch_code_rect"],
        reference_number_rect: data["reference_number_rect"],
        debt_purchase_date: data["debt_purchase_date"], // fecha operación rectificación
        currency_rect: data["currency_rect"],
        amount_rect: data["amount_rect"],
        term_rect: data["term_rect"],
        transaction_type_rect: data["transaction_type_rect"],
        default_date_rect: data["default_date_rect"],
        amount_fees_rect: data["amount_fees_rect"],
        //movimiento_rectificacion:data["movimiento_rectificacion"],
        //serie:data["serie"],
        //form:data["form"],
        //verificacion_data_empresa:data["verificacion_data_empresa"],
        //verificacion_direcion:data["verificacion_direcion"],

    }

}


export const creditDefaultConsumer = (data) => {
    return {
        // Los 2 tabs generan las 2 columnas vacías que el layout del CSV espera antes de afiliado.
        afiliado: `\t\t${data["afiliado"]}`,
        sucursal: data["sucursal"],
        fecha_info: data["fecha_info"],
        referencia: data["referencia"],
        fecha_datos_cliente: data["fecha_datos_cliente"],
        tipo_documento: data["tipo_documento"],
        pais_documento: data["pais_documento"],
        numero_documento: data["numero_documento"],
        primer_apellido: data["primer_apellido"],
        segundo_apellido: data["segundo_apellido"],
        primer_nombre: data["primer_nombre"],
        segundo_nombre: data["segundo_nombre"],
        fecha_nacimiento: data["fecha_nacimiento"],
        sexo: data["sexo"],
        fecha_datos_personales: data["fecha_datos_personales"],
        estado_civil: data["estado_civil"],
        tipo_documento_conyuge: data["tipo_documento_conyuge"],
        pais_documento_conyuge: data["pais_documento_conyuge"],
        numero_documento_conyuge: data["numero_documento_conyuge"],
        primer_apellido_conyuge: data["primer_apellido_conyuge"],
        segundo_apellido_conyuge: data["segundo_apellido_conyuge"],
        primer_nombre_conyuge: data["primer_nombre_conyuge"],
        segundo_nombre_conyuge: data["segundo_nombre_conyuge"],
        fecha_datos_fallecimiento: data["fecha_datos_fallecimiento"],
        fecha_publicacion_fallecimiento: data["fecha_publicacion_fallecimiento"],
        fecha_incorporacion_fallecimiento: data["fecha_incorporacion_fallecimiento"],
        email: data["email"],
        fecha_datos_domicilio: data["fecha_datos_domicilio"],
        propietario_inquilino_personal: data["propietario_inquilino_personal"],
        calle_personal: data["calle_personal"],
        numero_puerta_personal: data["numero_puerta_personal"],
        apartamento_personal: data["apartamento_personal"],
        piso_personal: data["piso_personal"],
        complemento_personal: data["complemento_personal"],
        departamento_personal: data["departamento_personal"],
        localidad_personal: data["localidad_personal"],
        codigo_postal_personal: data["codigo_postal_personal"],
        barrio_personal: data["barrio_personal"],
        fecha_datos_fono_personal: data["fecha_datos_fono_personal"],
        telefono_personal: data["telefono_personal"],
        fecha_datos_celular_personal: data["fecha_datos_celular_personal"],
        celular_personal: data["celular_personal"],
        fecha_datos_empleo: data["fecha_datos_empleo"],
        ocupacion: data["ocupacion"],
        empresa_empleo: data["empresa_empleo"],
        rubro_empleo: data["rubro_empleo"],
        ingreso_empleo: data["ingreso_empleo"],
        calle_empleo: data["calle_empleo"],
        numero_puerta_empleo: data["numero_puerta_empleo"],
        apartamento_empleo: data["apartamento_empleo"],
        piso_empleo: data["piso_empleo"],
        complemento_empleo: data["complemento_empleo"],
        departamento_empleo: data["departamento_empleo"],
        localidad_empleo: data["localidad_empleo"],
        codigo_postal_empleo: data["codigo_postal_empleo"],
        fecha_datos_fono_empleo: data["fecha_datos_fono_empleo"],
        telefono_empleo: data["telefono_empleo"],
        fecha_operacion: data["fecha_operacion"],
        moneda_incumplimiento: data["moneda_incumplimiento"],
        monto_solicitado: data["monto_solicitado"],
        plazo: data["plazo"],
        tipo_operacion: data["tipo_operacion"],
        fecha_incumplimiento: data["fecha_incumplimiento"],
        saldo_deudor: data["saldo_deudor"],
        afiliado_rectificacion: data["afiliado_rectificacion"],
        sucursal_rectificacion: data["sucursal_rectificacion"],
        referencia_rectificacion: data["referencia_rectificacion"],
        fecha_operacion_rectificacion: data["fecha_operacion_rectificacion"],
        moneda_rectificacion: data["moneda_rectificacion"],
        monto_solicitado_rectificacion: data["monto_solicitado_rectificacion"],
        plazo_rectificacion: data["plazo_rectificacion"],
        tipo_operacion_rectificacion: data["tipo_operacion_rectificacion"],
        fecha_incumplimiento_rectificacion: data["fecha_incumplimiento_rectificacion"],
        saldo_rectificacion: data["saldo_rectificacion"],
        movimiento_rectificacion: data["movimiento_rectificacion"],
        serie: data["serie"],
        form: data["form"],
        verificacion_data_personal_2: data["verificacion_data_personal_2"],
        verificacion_data_personal_3: data["verificacion_data_personal_3"],
        verificacion_direccion: data["verificacion_direccion"],
        verificacion_empleo: data["verificacion_empleo"]
    }
}



export const creditDefaultCommercial = (data) => {
    return {
        // Los 2 tabs generan las 2 columnas vacías que el layout del CSV espera antes de afiliado.
        afiliado: `\t\t${data["afiliado"]}`,
        sucursal: data["sucursal"],
        fecha_info: data["fecha_info"],
        referencia: data["referencia"],
        rut: data["rut"],
        nombre: data["nombre"],
        razon_social: data["razon_social"],
        giro_comercial: data["giro_comercial"],
        inicio_actividad: data["inicio_actividad"],
        fecha_datos_empresa: data["fecha_datos_empresa"],
        propietario_inquilino_empresa: data["propietario_inquilino_empresa"],
        calle_empresa: data["calle_empresa"],
        numero_puerta_empresa: data["numero_puerta_empresa"],
        apartamento_empresa: data["apartamento_empresa"],
        piso_empresa: data["piso_empresa"],
        complemento_empresa: data["complemento_empresa"],
        departamento_empresa: data["departamento_empresa"],
        localidad_empresa: data["localidad_empresa"],
        codigo_postal_empresa: data["codigo_postal_empresa"],
        telefono_empresa: data["telefono_empresa"],
        celular_empresa: data["celular_empresa"],
        email_empresa: data["email_empresa"],
        fecha_operacion: data["fecha_operacion"],
        moneda_incumplimiento: data["moneda_incumplimiento"],
        monto_solicitado: data["monto_solicitado"],
        plazo: data["plazo"],
        tipo_operacion: data["tipo_operacion"],
        fecha_incumplimiento: data["fecha_incumplimiento"],
        saldo_deudor: data["saldo_deudor"],
        afiliado_rectificacion: data["afiliado_rectificacion"],
        sucursal_rectificacion: data["sucursal_rectificacion"],
        referencia_rectificacion: data["referencia_rectificacion"],
        fecha_operacion_rectificacion: data["fecha_operacion_rectificacion"],
        moneda_rectificacion: data["moneda_rectificacion"],
        monto_solicitado_rectificacion: data["monto_solicitado_rectificacion"],
        plazo_rectificacion: data["plazo_rectificacion"],
        tipo_operacion_rectificacion: data["tipo_operacion_rectificacion"],
        fecha_incumplimiento_rectificacion: data["fecha_incumplimiento_rectificacion"],
        saldo_rectificacion: data["saldo_rectificacion"],
        movimiento_rectificacion: data["movimiento_rectificacion"],
        serie: data["serie"],
        form: data["form"],
        verificacion_data_empresa: data["verificacion_data_empresa"],
        verificacion_direccion: data["verificacion_direccion"]
    }
}



